import { ILoanComplianceCharge } from '../../../interfaces';

/**
 * Whether a charge can be paid: it still has something outstanding, and its amount is settled. The
 * one rule deciding both whether the log-payment button appears and which charges the modal offers
 * -- written once so the two can't drift into a button that opens a form with nothing to select.
 *
 * The amount has to be final because the API refuses payment against a charge that is still an
 * estimate, and it is right to: the figure falls as the account repays, so paying it early can
 * overpay a charge that has no way to hand the difference back. Offering the quarter still running
 * would put a 400 behind a row the user was invited to choose.
 *
 * Here rather than in Columns.tsx, which is where it started: neither caller wants a column config,
 * and the modal has no reason to pull a module full of React cells in behind this.
 */
export function isChargeOpen (charge: ILoanComplianceCharge) {
  return !charge.is_paid && charge.is_amount_final;
}
